import { SUPPORT_EMAIL } from "@/lib/support";

// BRK-S325 — where a contractor lands after closing the bank connection
// (Plaid, hosted by Lendflow) before finishing. PUBLIC: the contractor has no
// portal sign-in, and the page carries NO account or personal data — it is
// reached from an emailed link and says only what happened, that nothing was
// lost, how to try again, and who to contact (Daniel's pre-approval feedback
// #2: closing Plaid with the X left a blank white page).
export function BankConnectionClosedPage() {
  return (
    <section className="mx-auto flex w-full max-w-prose flex-col gap-4 py-12 text-left sm:py-16">
      <h1 className="text-title text-brk-text">Bank connection not finished</h1>
      <p className="text-brk-text">
        You closed the bank connection before finishing. Nothing was lost — use
        the link in your email to try again.
      </p>
      <p className="text-brk-dim">
        The link stays the same, so you can reopen it from the same email
        whenever you’re ready.
      </p>
      <p className="text-brk-dim">
        Questions? Contact Signal Specialty at{" "}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="break-all text-brk-accent hover:underline"
        >
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
    </section>
  );
}
